import { useForm } from "react-hook-form";
import {
  useAccountResetMutation,
  useAccountSetPasswordMutation,
} from "app/services/api/authorisationApi";
import { AccountResetRequest } from "app/services/api/types/authorisation/requests/AccountResetRequest";
import { useRouter } from "expo-router";
import { useDisplayToast } from "ui/hooks/useDisplayToast";
import { ToastModel } from "ui/types/ToastModel";
import { LoginPath } from "app/constants/routePaths";
import { PasswordSetType } from "../types/PasswordSetType";

interface Props {
  email: string;
  token: string;
  type: PasswordSetType;
}
export const useAccountPasswordSet = ({ email, token, type }: Props) => {
  const router = useRouter();
  const { showNewToast } = useDisplayToast();

  const [triggerReset, { isLoading: isLoadingReset }] =
    useAccountResetMutation();
  const [triggerPasswordSet, { isLoading: isLoadingSet }] =
    useAccountSetPasswordMutation();

  const { control, handleSubmit } = useForm<AccountResetRequest>({
    defaultValues: {
      email,
      password: "",
      password_confirmation: "",
      token,
    },
  });

  const handleToast = (toast: ToastModel) => {
    showNewToast(toast);
  };

  const submitForm = handleSubmit(async (data: AccountResetRequest) => {
    try {
      if (type === "reset") await triggerReset(data).unwrap();
      else await triggerPasswordSet(data).unwrap();

      handleToast({
        id: "reset-password-success",
        title: "Password successfully updated",
        message: "Please log in again with your new credentials.",
        type: "success",
      });

      router.replace(LoginPath);
    } catch (e) {
      console.error("Error:", e);
      const errorMessage = e?.data?.message || "An unexpected error occurred.";
      handleToast({
        id: "reset-error",
        title: errorMessage,
        message: "Please go back to 'Forgot Password' and try again.",
        type: "error",
      });
    }
  });

  return { control, submitForm, isLoading: isLoadingReset || isLoadingSet };
};
